import React, { useEffect, useState } from 'react';
// import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { ThemeContext } from 'styled-components';
import { Helmet } from 'react-helmet';
// import { ISO_DATE_FORMAT } from '../../../common/constants';
import { cloneDeep } from 'lodash';
import {
  AmountDisclaimerContainer,
  AmountDisclaimerText,
  AmountContainer,
  AmountHeader,
  AmountText,
  // DateChoice, //NOTE: Several Stubbed out lines of code that can be added
  //                     back if scheduled payment request api is fixed to allow anon.
  // DateContainer,
  FullAmountCard,
  InformationArea,
  InstructionsContainer,
  MinimumAmountCard,
  OtherAmountCard,
  PartialAmountInput,
  // PayDateHeader,
  PaymentTypeContainer,
  PaymentTypeHeader,
  RadioChoice,
  StyledInfoIcon,
  SubHeader,
} from './styles';
import {
  setActiveStep,
  setNextButtonClicked,
  setNextButtonDisabled,
  setInstrumentToPayWith,
  setAmountToPay,
  // setPayDate,
  setRadioAmountType,
} from '../makePaymentAnonymousReducer';
import TooltipInfo from '../../../common/tooltip';
import { getText } from '../../../../utils/i18n';
import FundingInstruments from './fundingInstruments';
import {ga4Event} from "../../../../utils/google-analytics-4";

export const bankAccountTypes = [
  {
    label: 'Personal Checking',
    value: 'PChecking',
    typeCd: 'Checking',
    entryCd: 'PPD',
  },
  {
    label: 'Personal Savings',
    typeCd: 'Savings',
    value: 'Savings',
    entryCd: 'PPD',
  },
  {
    label: 'Commercial Checking',
    value: 'CChecking',
    typeCd: 'Checking',
    entryCd: 'CCD',
  },
];
const Step3 = (props) => {
  const {
    activeStep,
    amountToPay,
    billSelected,
    dispatch,
    nextButtonClicked,
    instrumentToPayWith,
    i18n,
    otherAmountAllowed,
    // schedulePaymentsAllowed,
    radioAmountType,
  } = props;

  const isStatementAccount = billSelected.billingAccount.accountNumber.slice(0, 2) === 'SA';
  let [radioAmountChecked, setRadioAmountChecked] = useState(radioAmountType);
  let [paymentAmount, setPaymentAmount] = useState('');
  const { openAmt, totalAmt } = billSelected.billingAccount;
  let [partialAmount, setPartialAmount] = useState(
    amountToPay && amountToPay !== totalAmt ? amountToPay : '',
  );
  // let [dateChoice, setDateChoice] = React.useState(moment().format(ISO_DATE_FORMAT));

  useEffect(() => {
    // GA4 event for make payment workflow step three
    ga4Event({
      category: 'make-a-payment',
      action: 'step_three',
      label: 'anonymous_payment',
    });
    dispatch(setNextButtonDisabled(true));
  }, []);

  const isValidPartialAmt = (amount) => {
    return (
      parseFloat(amount) >= parseFloat(openAmt) &&
      parseFloat(amount) <= parseFloat(totalAmt) &&
      parseFloat(amount) !== parseFloat(0)
    );
  };

  useEffect(() => {
    if (
      (instrumentToPayWith && radioAmountChecked !== 2 && radioAmountChecked !== -1) ||
      (instrumentToPayWith &&
        radioAmountChecked !== -1 &&
        radioAmountChecked === 2 &&
        isValidPartialAmt(partialAmount))
    ) {
      dispatch(setNextButtonDisabled(false));
    } else {
      dispatch(setNextButtonDisabled(true));
    }
  }, [radioAmountChecked, instrumentToPayWith, partialAmount]);
  const nextButtonClickHandler = () => {
    if (radioAmountChecked === 2) {
      dispatch(setAmountToPay(partialAmount));
      // dispatch(setPayDate(dateChoice));
    } else if (radioAmountChecked === 1) {
      dispatch(setAmountToPay(openAmt));
    } else {
      dispatch(setAmountToPay(totalAmt));
    }
    let newInstrument = cloneDeep(instrumentToPayWith);

    dispatch(setInstrumentToPayWith(newInstrument));
    dispatch(setNextButtonClicked(false));
    dispatch(setRadioAmountType(radioAmountChecked));
    dispatch(setActiveStep(3));
  };
  useEffect(() => {
    if (activeStep === 2 && nextButtonClicked === true) {
      nextButtonClickHandler();
    }
  }, [nextButtonClicked, activeStep]);
  return (
    <>
      <Helmet>
        <title>Make Payment - Select Payment Method</title>
      </Helmet>
      <>
        {i18n?.makePaymentAnonymous?.stepThree?.instructions && (
          <InstructionsContainer
            dangerouslySetInnerHTML={{ __html: i18n.makePaymentAnonymous.stepThree.instructions }}
          />
        )}
        {/* <SubHeader>Select Date</SubHeader>
        <DateContainer>
          <FullAmountCard>
            <PayDateHeader>
              Payment Date
              <TooltipInfo title={getText(i18n, 'makePayment.stepTwo.paymentDateTooltip')} />
              <DateChoice
                id={'PaymentDate'}
                disabled={!schedulePaymentsAllowed}
                value={dateChoice}
                min={moment().format(ISO_DATE_FORMAT)}
                onChange={e => setDateChoice(e.target.value)}
              />
            </PayDateHeader>
          </FullAmountCard>
        </DateContainer> */}
        <SubHeader>Select Amount</SubHeader>
        {i18n?.makePaymentAnonymous?.stepThree?.selectAmountInstructions && (
          <InstructionsContainer
            dangerouslySetInnerHTML={{
              __html: i18n.makePaymentAnonymous.stepThree.selectAmountInstructions,
            }}
          />
        )}
        <AmountContainer>
          <label htmlFor="PayoffAmountRadio">
            <FullAmountCard>
              <RadioChoice
                aria-label="Select Amount Payoff Amount"
                id={'PayoffAmountRadio'}
                checked={radioAmountChecked === 0}
                onChange={() => {
                  setPaymentAmount(totalAmt);
                  setRadioAmountChecked(0);
                }}
              />
              <AmountHeader>
                Payoff Amount
                <TooltipInfo title={getText(i18n, 'makePayment.stepTwo.payOffAmountTooltip')} />
              </AmountHeader>
              <AmountText id={'PayoffAmount'}>${totalAmt}</AmountText>
            </FullAmountCard>
          </label>
          {openAmt !== '0.00' && (
            <label htmlFor="CurrentAmountDueRadio">
              <MinimumAmountCard>
                <RadioChoice
                  aria-label="Select Amount Current Due"
                  id={'CurrentAmountDueRadio'}
                  checked={radioAmountChecked === 1}
                  onChange={() => {
                    setPaymentAmount(openAmt);
                    setRadioAmountChecked(1);
                  }}
                />
                <AmountHeader>Current Due</AmountHeader>
                <AmountText id={'CurrentDueAmount'}>${openAmt}</AmountText>
              </MinimumAmountCard>
            </label>
          )}
          {otherAmountAllowed && !isStatementAccount && (
            <label htmlFor="PartialAmountRadio">
              <OtherAmountCard>
                <RadioChoice
                  aria-label="Select Amount Partial Amount"
                  id={'PartialAmountRadio'}
                  checked={radioAmountChecked === 2}
                  onChange={() => {
                    setRadioAmountChecked(2);
                  }}
                />
                <AmountHeader>
                  {' '}
                  Partial Amount
                  <TooltipInfo title={getText(i18n, 'makePayment.stepTwo.partialAmountTooltip')} />
                </AmountHeader>
                <PartialAmountInput
                  type="number"
                  aria-label="Partial Amount"
                  value={partialAmount}
                  onChange={(e) => {
                    setPartialAmount(e.target.value);
                    setRadioAmountChecked(2);
                  }}
                  onBlur={() => setPartialAmount(parseFloat(partialAmount).toFixed(2))}
                />
                <InformationArea>
                  <StyledInfoIcon />
                  Partial amount must be between payoff amount and current due.
                </InformationArea>
              </OtherAmountCard>
            </label>
          )}
        </AmountContainer>
        <PaymentTypeContainer>
          <PaymentTypeHeader>Payment Type</PaymentTypeHeader>
          {i18n?.makePaymentAnonymous?.stepThree?.genericPaymentTypeInstructions && (
            <InstructionsContainer
              dangerouslySetInnerHTML={{
                __html: i18n.makePaymentAnonymous.stepThree.genericPaymentTypeInstructions,
              }}
            />
          )}
          {instrumentToPayWith &&
            (instrumentToPayWith?.methodCd == 'Credit Card' ||
              instrumentToPayWith?.sourceType === 'CreditCard') &&
            i18n?.makePaymentAnonymous?.stepThree?.creditCardSpecificInstructions && (
              <InstructionsContainer
                dangerouslySetInnerHTML={{
                  __html: i18n.makePaymentAnonymous.stepThree.creditCardSpecificInstructions,
                }}
              />
            )}
          <FundingInstruments />
        </PaymentTypeContainer>
        <AmountDisclaimerContainer>
          <AmountDisclaimerText>
            <StyledInfoIcon />
            {getText(
              i18n,
              'general.paymentAmountDisclaimer',
              'Final payment amount may change depending on the payment type selected and applicable fees.',
            )}
          </AmountDisclaimerText>
        </AmountDisclaimerContainer>
      </>
    </>
  );
};
Step3.displayName = 'MakePaymentAnonymousStep3';
Step3.propTypes = {
  activeStep: PropTypes.any,
  amountToPay: PropTypes.any,
  dispatch: PropTypes.func,
  nextButtonClicked: PropTypes.bool,
  i18n: PropTypes.object,
  radioAmountType: PropTypes.any,
  billSelected: PropTypes.any,
  schedulePaymentsAllowed: PropTypes.any,
  instrumentToPayWith: PropTypes.any,
  otherAmountAllowed: PropTypes.any,
};

export const mapStateToProps = (state) => ({
  activeStep: state.makePaymentAnonymousSlice.activeStep,
  amountToPay: state.makePaymentAnonymousSlice.amountToPay,
  billSelected: state.makePaymentAnonymousSlice.billSelected,
  isLoading: state.makePaymentAnonymousSlice.isLoading,
  instrumentToPayWith: state.makePaymentAnonymousSlice.instrumentToPayWith,
  nextButtonClicked: state.makePaymentAnonymousSlice.nextButtonClicked,
  nextButtonDisabled: state.makePaymentAnonymousSlice.nextButtonDisabled,
  paymentConfigId: state.configurationSlice.features.paymentConfigIds,
  i18n: state.i18nSlice.i18n,
  radioAmountType: state.makePaymentAnonymousSlice.radioAmountType,
  schedulePaymentsAllowed: state.configurationSlice.features.features.scheduledPayments,
  otherAmountAllowed: state.configurationSlice.features.features.otherPaymentAmountAllowed,
});
export default connect(mapStateToProps)(Step3);
